document.addEventListener("DOMContentLoaded", function () {
    // Config from Shopify Section
    let sectionOffers = window.SpinWheelOffers;
    if (!sectionOffers || sectionOffers.length === 0) {
        sectionOffers = [
            { label: "Extra 5% Off", value: "5% OFF", color: "#6C3483", textColor: "#fff" },
            { label: "Try Again!", value: "NO LUCK", color: "#A569BD", textColor: "#fff" },
            { label: "Extra 15% Off", value: "15% OFF", color: "#6C3483", textColor: "#fff" },
            { label: "Rs 100 Off", value: "Rs 100", color: "#A569BD", textColor: "#fff" },
            { label: "Extra 10% Off", value: "10% OFF", color: "#6C3483", textColor: "#fff" },
            { label: "Rs 200 Off", value: "Rs 200", color: "#A569BD", textColor: "#fff" },
        ];
    }
    const OFFERS = sectionOffers;

    // Session Check
    if (sessionStorage.getItem('spinWheelClosed') === 'true') {
        return;
    }

    // Check if modal exists (rendered by Liquid section)
    if (!document.getElementById("spin-wheel-modal")) {
        // console.warn("Spin Wheel: Modal element not found. Make sure the section is enabled.");
        return;
    }

    // Elements
    const modal = document.getElementById("spin-wheel-modal");
    const closeBtn = document.querySelector(".spin-close");
    const canvas = document.getElementById("spin-canvas");
    const ctx = canvas.getContext("2d");
    const form = document.getElementById("spin-form");
    const initialView = document.getElementById("spin-initial-view");
    const resultView = document.getElementById("spin-result-view");
    const wonValueDisplay = document.getElementById("spin-won-value");
    const continueBtn = document.getElementById("spin-continue-btn");

    let isSpinning = false;



    // Initial Show Logic (Restored)
    setTimeout(() => {
        const m = document.getElementById("spin-wheel-modal");
        if (m) {
            console.log("Spin Wheel: Showing modal");
            m.classList.add("visible");
            m.style.display = 'flex';
        }
    }, 1500);

    function drawWheel() {
        try {
            if (!canvas || !ctx) {
                console.error("Spin Wheel: Canvas or Context not found");
                return;
            }
            if (!OFFERS || OFFERS.length === 0) {
                console.error("Spin Wheel: OFFERS is empty", OFFERS);
                return;
            }

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            console.log("Spin Wheel: Drawing wheel with " + OFFERS.length + " offers");

            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2;
            // Reduce radius slightly to fit the thick border
            const outsideRadius = (canvas.width / 2) - 25;
            const textRadius = outsideRadius - 60;

            // 1. Draw Outer Rim (Dark Purple)
            ctx.save();
            ctx.beginPath();
            ctx.arc(centerX, centerY, outsideRadius + 20, 0, 2 * Math.PI);
            ctx.fillStyle = "#4A235A"; // Dark Purple Rim
            ctx.fill();
            ctx.lineWidth = 5;
            ctx.strokeStyle = "#F4D03F"; // Gold/Yellow Border
            ctx.stroke();
            ctx.restore();

            // 2. Draw Segments
            const arc = (2 * Math.PI) / OFFERS.length;
            const startAngleOffset = -arc / 2; // Offset to center the first segment at 0 radians (Right pointer)

            OFFERS.forEach((offer, i) => {
                const angle = i * arc + startAngleOffset;
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.arc(centerX, centerY, outsideRadius, angle, angle + arc);
                ctx.lineTo(centerX, centerY);
                ctx.fillStyle = offer.color;
                ctx.fill();
                ctx.stroke();
                ctx.restore();

                // 3. Draw Text
                ctx.save();
                ctx.translate(centerX, centerY);
                ctx.rotate(angle + arc / 2);
                ctx.textAlign = "right";
                ctx.fillStyle = offer.textColor;
                ctx.font = "bold 32px 'GeneralSans-Bold', sans-serif";
                ctx.fillText(offer.label, textRadius, 10);
                ctx.restore();
            });

            // 4. Draw Decorative Dots on Rim
            const totalDots = 12;
            const dotRadius = (outsideRadius + 20) - 10;
            const angleStep = (2 * Math.PI) / totalDots;

            for (let i = 0; i < totalDots; i++) {
                const dotAngle = i * angleStep;
                const dx = centerX + Math.cos(dotAngle) * dotRadius;
                const dy = centerY + Math.sin(dotAngle) * dotRadius;

                ctx.beginPath();
                ctx.arc(dx, dy, 6, 0, 2 * Math.PI);
                ctx.fillStyle = "#F4D03F"; // Gold Dot
                ctx.fill();
            }

            // 5. Center Hub (Managed via HTML/CSS now)

        } catch (err) {
            console.error("Spin Wheel Drawing Error:", err);
        }
    }

    drawWheel();

    // Spin Logic (Click based to prevent submission reload issues)
    const spinButtonSubmit = document.getElementById("spin-btn-submit");
    if (spinButtonSubmit) {
        spinButtonSubmit.addEventListener("click", function (e) {
            e.preventDefault(); // Stop form submission immediately

            // Check validation
            if (form && !form.checkValidity()) {
                form.reportValidity(); // Show browser validation error
                return;
            }

            if (isSpinning) return;

            // Validate Mobile Number here if needed
            isSpinning = true;
            spinButtonSubmit.disabled = true;
            spinButtonSubmit.textContent = "Spinning...";

            // Spin Calculations
            const spins = 5;

      // 1. Pre-determine Winner with PRIORITY (Weights)
            // Define weights for each segment. Higher number = higher chance.
            // Indices: 0: 5% Off, 1: Try Again, 2: 15% Off, 3: 100 Off, 4: 10% Off, 5: 200 Off
            // Total doesn't need to be 100, just relative ratios.
            const weights = [100, 0, 0, 0, 0, 0];

            // Fallback if weights length doesn't match offers
            if (weights.length !== OFFERS.length) {
                // If mismatch, just fill with 1s
                while (weights.length < OFFERS.length) weights.push(1);
            }

            let totalWeight = weights.reduce((acc, w) => acc + w, 0);
            let randomNum = Math.random() * totalWeight;
            let winningIndex = 0;

            for (let i = 0; i < weights.length; i++) {
                if (randomNum < weights[i]) {
                    winningIndex = i;
                    break;
                }
                randomNum -= weights[i];
            }
            const winner = OFFERS[winningIndex];

            // 2. Calculate Angle to Land on Winner
            // Segment i is centered at i * segmentAngle.
            // Pointer is at 0. We need to rotate canvas by -(i * segmentAngle) to bring it to pointer.
            const segmentAngle = 360 / OFFERS.length;

            // Add randomness within the segment (safe zone 80%) to avoid landing on lines
            const randomOffset = (Math.random() - 0.5) * (segmentAngle * 0.8);

            const targetAngle = (winningIndex * segmentAngle) + randomOffset;
            const totalRotation = (spins * 360) + targetAngle;

            // Apply CSS transition
            canvas.style.transition = "transform 4s cubic-bezier(0.17, 0.67, 0.12, 0.99)";
            canvas.style.transform = `rotate(-${totalRotation}deg)`;

            setTimeout(() => {
                isSpinning = false;
                // Winning logic is pre-calculated above, 'winner' is available in closure

                // 2. Prepare API Payload
                const phoneInput = form.querySelector(".spin-input");

                function generateTBMCode() {
                    return 'RTF' + Math.random().toString(36).substr(2, 4).toUpperCase();
                }
                const tbmCode = generateTBMCode();

                // Base Payload
                const payload = {
                    senderId: "69412a21286bec0079f6b95f",
                    number: phoneInput.value,
                    name: "Shopify Visitor",
                    tags: "spin by Wheel",
                    source: "Shopify",
                    discountCode: tbmCode,
                    discount_endtime: 3600
                };

                // Map Offer to Payload
                const label = winner.label;
                if (label.includes("5%")) { payload.minAmount = "100"; payload.percentage = "5"; }
                else if (label.includes("10%")) { payload.minAmount = "100"; payload.percentage = "10"; }
                else if (label.includes("15%")) { payload.minAmount = "100"; payload.percentage = "15"; }
                else if (label.includes("100")) { payload.discountAmount = 100; }
                else if (label.includes("200")) { payload.discountAmount = 200; }
                else {
                    payload.noDiscount = true; // Try Again or others
                }
 if (payload.noDiscount) {
                    // Logic for Try Again if you want to send API request even for failure
                    // For now, let's keep local handling to avoid spamming API with 'no luck' unless requested differently.
                    // User asked "kasi banegi" (how would it be made?). 
                    // If we WANT to send it:
                    /*
                    delete payload.discountAmount;
                    delete payload.minAmount;
                    delete payload.percentage;
                    payload.discountCode = "TBMFREE"; 
                    // proceed to fetch...
                    */

                    // Current logic: Just show local message
                    showResult({ value: "Better Luck Next Time!", label: "Try Again" });
                    return;
                }

                // If "Try Again", skip API or don't show code?
             

                // 3. Call API
                const spinBtn = form.querySelector(".spin-btn");
                spinBtn.textContent = "Generating Coupon...";

                const API_ENDPOINT = "https://app.retner.ai/api/shopify/spinDiscount";

                console.log("Spin API Request Payload:", payload);

                fetch(API_ENDPOINT, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                })
                    .then(response => {
                        // Start showing result view immediately? Or wait? 
                        // Let's show result but with the NEW code.
                        if (!response.ok) { console.error("API Error", response); }
                        return response.json();
                    })
                    .then(data => {
                        console.log("Spin API Success Data:", data);

                        // Update the winner object with the generated code
                        const finalOffer = { ...winner, value: tbmCode };

                        // Show Result UI
                        showResult(finalOffer, true); // Pass true to indicate it's a code
                    })
                    .catch(err => {
                        console.error("[Spin Popup] API error:", err);
                        // Fallback: Show the generated code locally even if API fails
                        // We assume the user still gets the discount visually
                        const fallbackOffer = { ...winner, value: tbmCode };
                        showResult(fallbackOffer, true);
                    });

            }, 4000);
        });
    }



    // Close Logic
    function closeModal() {
        sessionStorage.setItem('spinWheelClosed', 'true');
        modal.classList.remove("visible");
        // Optional: slight delay to allow transition before display none
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
    }
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (continueBtn) continueBtn.addEventListener("click", closeModal);


    function showResult(offer, isCode = false) {
        sessionStorage.setItem('spinWheelClosed', 'true');
        if (initialView) initialView.style.display = "none";
        if (resultView) {
            resultView.style.display = "flex";
            // Ensure opacity is 1 just in case animation logic hides it
            resultView.style.opacity = "1";
        }

        if (wonValueDisplay) {
            // Dynamic Prize Label (e.g. "Extra 10% Off")
            let prizeLabel = document.getElementById("spin-prize-label-dynamic");
            if (!prizeLabel) {
                prizeLabel = document.createElement("div");
                prizeLabel.id = "spin-prize-label-dynamic";
                // Basic inline styles to match theme
                prizeLabel.style.fontSize = "22px";
                prizeLabel.style.fontWeight = "bold";
                prizeLabel.style.color = "#4A235A";
                prizeLabel.style.marginBottom = "5px";
                prizeLabel.style.textAlign = "center";

                // Insert before the code box
                wonValueDisplay.parentNode.insertBefore(prizeLabel, wonValueDisplay);
            }
            prizeLabel.textContent = offer.label;

            if (isCode) {
                wonValueDisplay.innerHTML = `
                  <div style="font-size:0.8em; margin-bottom:5px;">Code Unlocked:</div>
                  <strong>${offer.value}</strong>
                  <button class="spin-btn" id="copy-code-btn" style="margin-top:15px; padding:8px 15px; font-size:14px; width:auto; display:inline-block;">Copy Code</button>
                 `;

                // Initialize Copy Logic
                setTimeout(() => {
                    const copyBtn = document.getElementById("copy-code-btn");
                    if (copyBtn) {
                        copyBtn.addEventListener("click", function (e) {
                            e.preventDefault();
                            navigator.clipboard.writeText(offer.value).then(() => {
                                copyBtn.textContent = "Copied!";
                                copyBtn.style.background = "#2ecc71"; // Success Green
                                setTimeout(() => {
                                    copyBtn.textContent = "Copy Code";
                                    copyBtn.style.background = ""; // revert
                                }, 2000);
                            });
                        });
                    }
                }, 0);
            } else {
                wonValueDisplay.textContent = offer.value;
                // Hide label if it's just a text message like "Try Again" to avoid duplication?
                // The prompt implies they want to see "Extra 10%" explicitly.
                // If offer.value is same as label (case for non-code), it might be duplicate.
                // But usually for non-code, value is "Better Luck..." and label is "Try Again".
                // So displaying label "Try Again" above "Better Luck..." is actually good.
            }
        }

        // Confetti
        fireConfetti();
    }

    function fireConfetti() {

        // Simple JS confetti or relying on library. 
        // Since I can't easily add a library without CDN, let's make simple CSS confetti or simple particle bloom.
        // For now, just the UI transition.
    }
});
